class InfoCard {

    constructor(parent, data) {
        this.items = []
        document.querySelectorAll('.info-card').forEach((el) => {
            this.items.push(new InfoCardItem(this, el))
        })
        window.addEventListener('resize', () => {
            this.recalculate()
        })
    }

    recalculate() {
        this.items.forEach(item => {
            item.recalculate()
        })
    }

    reset() {
        this.items.forEach(item => {
            item.reset()
        })
    }
}

class InfoCardItem {
    constructor(parent, el) {
        this.parent = parent
        this.el = el

        this.el.addEventListener('mouseover', () => {
            this.recalculate()
        })
    }
    recalculate() {
        let mql = window.matchMedia('(max-width: 500px)');

        if (false === mql.matches) {
            this.reset()
            return
        }

        this.reset()
        this.calculate()
    }
    calculate() {
        this.el.querySelectorAll('.info-card__answer').forEach((el) => {
            const leftOffset = ((window.innerWidth - el.getBoundingClientRect().width) / 2) - el.getBoundingClientRect().left
            el.style.left = leftOffset + 'px'
        })
    }
    reset() {
        this.el.querySelectorAll('.info-card__answer').forEach((el) => {
            el.style.left = ''
        })
    }
}

export default InfoCard;